import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import "./Login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const nav = useNavigate();
    const [show, setShow] = useState(false);

  // If user is already logged in, redirect to Upload and replace history
  const stored = sessionStorage.getItem("password");
  if (stored) {
    return <Navigate to="/Onas/Podstrani/Login/Upload" replace />;
  }

  async function handleLogin() {
    setErr("");
    try {
      const res = await fetch(
        "https://purple-king-9edc.pandabitstudio.workers.dev/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password: pw }),
        }
      );
      if (!res.ok) {
        setErr("Napačno geslo");
        return;
      }
      sessionStorage.setItem("password", pw);
      nav("/Onas/Podstrani/Login/Upload", { replace: true });
    } catch {
      setErr("Network error");
    }
  }

  return (
      <div className="login-container">
      <form
        className="login-card"
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <img
          src="/Slike/Rotary.png"
          alt="Rotary Club Žalec Logo"
          style={{ height: "80px", marginBottom: "20px" }}
        />

        <div className="input-group" style={{ position: "relative" }}>
          <input
            id="password"
            type={show ? "text" : "password"}
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            className="login-input"
            autoComplete="off"
            style={{ paddingRight: "2.5rem" }}
          />
          <label htmlFor="password" className={pw ? "filled" : ""}>
            Vnesite geslo..
          </label>
          <button
            type="button"
            className="toggle-btn"
            aria-label={show ? "Skrij geslo" : "Pokaži geslo"}
            onClick={() => setShow((s) => !s)}
            style={{
              position: "absolute",
              top: "55%",
              right: "0.75rem",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 0,
            }}
          >
            {show ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
          </button>
        </div>

        {err && <div className="error-msg">{err}</div>}

        <button type="submit" className="login-btn">
          Vpis
        </button>
      </form>
    </div>
  );
}
